export default "__VITE_ASSET__ef38176a__"